import React, { memo, useMemo, useRef } from 'react';
import { MediaItem, PresentedMediaItem } from '../../stores/reducers/media';
import UseSyncMedia from '../main-video/use-sync-media';
import Socket from '../../connection/socket';

interface MediaAudioProps {
	id: string;
	mediaItem: MediaItem | undefined;
	mediaId: number;
	loop?: boolean;
	isPreloading: boolean;
	onLoadedDataOverride?: () => void;
	socket?: Socket | null;
	isEditingFeed: boolean;
	iterateLoadedMediaCount?: Function;
	presentedMediaItem?: PresentedMediaItem;
}

const MediaAudioSpotlight = ((
	{
		id,
		mediaItem,
		loop,
		isPreloading,
		onLoadedDataOverride,
		mediaId,
		socket,
		isEditingFeed,
		iterateLoadedMediaCount,
		presentedMediaItem,
	}: MediaAudioProps,
) => {
	if (!mediaItem) {
		return (
			<></>
		);
	}

	const src = useMemo(() => {
		const currentPage = presentedMediaItem?.currentPage ?? 1;
		const imageArray = mediaItem?.media_data.image_array ?? [''];
		return imageArray[currentPage - 1] ?? '';
	}, [
		mediaItem?.media_data.image_array,
		presentedMediaItem?.currentPage,
	]);
	const mediaElRef = useRef<HTMLAudioElement>(null);
	const echoCancelAudioRef = useRef<HTMLAudioElement>(null);
	const {

		onPlay,
		onEnded,
		onError,
		onLoadedData: onLoadedDataInitial,
		...otherSyncMediaProps
	} = UseSyncMedia({
		mediaElRef,
		echoCancelAudioRef,
		mediaId,
		mediaItem,
		socket,
		iterateLoadedMediaCount,
		isEditingFeed,
		presentedMediaItem,
		audioOnly: true,
		src,
	});

	const onLoadedData = useMemo(() => {
		if (isPreloading) {
			return () => {};
		} if (onLoadedDataOverride) {
			return onLoadedDataOverride;
		}
		return onLoadedDataInitial;
	}, [isPreloading, onLoadedDataInitial, onLoadedDataOverride]);

	const getAudioMimeType = (type: string) => {
		switch (type) {
			case 'aac':
				return 'audio/aac';
			case 'mp3':
				return 'audio/mpeg';
			case 'wav':
				return 'audio/wav';
			default:
				return '';
		}
	};

	const consolidatedListeners = isPreloading ? {} : {
		onEnded,
		onError,
		onPlay,
		...otherSyncMediaProps,
	};

	return (
		<>
			<audio
				id={id}
				ref={mediaElRef}
				className="media-audio"
				onPlay={onPlay}
				onEnded={onEnded}
				loop={loop}
				controls={true}
				onLoadedData={onLoadedData}
				{...consolidatedListeners}
				crossOrigin={'anonymous'}
			>
				<source
					src={src}
					type={getAudioMimeType(mediaItem?.type ?? '')}
				/>
			</audio>
			<audio
				ref={echoCancelAudioRef}
			></audio>

		</>
	);
});

export default memo(MediaAudioSpotlight);
